import $ from "jquery";
import {pinStyle, TABS} from "./constants";
import {$targets} from "../../../global/map-library";

$targets.resultTabs = $("#nav-tab");

// return a span styled as a checkmark if the incoming bool is true or hidden dash if false (for datatables.js sorting)
const $checkMark = (bool) => bool ? $("<span>").addClass("fas fa-check") : $("<span>").html("-").attr("hidden", "hidden");

//add <option>s to a select menu
function populateFilterMenu($filterMenu, options, selected) {
    $filterMenu.html("");
    options.forEach(o => {
        const $option = $("<option>").attr("value", o.value).html(o.label);
        if (o.value === selected) {
            $option.attr("selected", true);
        }
        $filterMenu.append($option);
    });
}

// return a pin color based on type and the current tab
function schoolStyle(school) {
    const activeTab = $(".nav-link.active", $targets.resultTabs).attr("id");
    if (activeTab === TABS.currentFacility) {
        switch (school.type) {
            case "ES":
                return pinStyle.elementary;
            case "HS":
                return pinStyle.highschool;
            default:
                return;
        }
    } else if (activeTab === TABS.utilization) {
        switch (school.utilizationStatus) {
            case "Efficient":
                return pinStyle.efficient;
            case "Underutilized":
                return pinStyle.underutilized;
            case "Overcrowded":
                return pinStyle.overcrowded;
            case "N/A":
                return pinStyle.na;
        }
    }

    if (activeTab === TABS.capital) {
        switch (school.type) {
            case "ES":
                return pinStyle.capitalES;
            case "HS":
                return pinStyle.capitalHS;
        }
    }
}

// return the icon image for a given marker type
function schoolClass(school) {
    const activeTab = $(".nav-link.active", $targets.resultTabs).attr("id");
    if (activeTab === TABS.currentFacility || activeTab === TABS.capital) {
        return school.type.replace(/\//g, '_');
    }
    if (activeTab === TABS.utilization) {
        return school.utilizationStatus.replace(/\//g, '_');
    }
}

function convertToInternationalCurrencySystem(labelValue) {

    // Nine Zeroes for Billions
    return Math.abs(Number(labelValue)) >= 1.0e+9

        ? (Math.abs(Number(labelValue)) / 1.0e+9).toFixed(2) + "B"
        // Six Zeroes for Millions
        : Math.abs(Number(labelValue)) >= 1.0e+6

            ? (Math.abs(Number(labelValue)) / 1.0e+6).toFixed(2) + "M"
            // Three Zeroes for Thousands
            : Math.abs(Number(labelValue)) >= 1.0e+3

                ? (Math.abs(Number(labelValue)) / 1.0e+3).toFixed(2) + "K"

                : Math.abs(Number(labelValue));

}

function $chartElements() {
    return $("<div>").addClass("chart-holder").html($("<canvas>"));
}

export {
    $checkMark,
    populateFilterMenu,
    schoolStyle,
    schoolClass,
    convertToInternationalCurrencySystem,
    $chartElements,
};
